import iconWind from "@/img/wind-detail-icon.svg";
import iconThunderstorm from "@/img/thunderstorm-detail-icon.svg";
import iconDust from "@/img/dust-detail.svg";
import iconSnow from "@/img/snow-detail.svg";
import iconRain from "@/img/rain-detail.svg";
import iconWave from "@/img/high-wave-detail.svg";
import iconHail from "@/img/hail-detail.svg";
import iconTemp from "@/img/high-temp-detail.svg";
import iconFrost from "@/img/frost-detail.svg";
import iconFog from "@/img/fog-icon-map.svg";

const layersData = [
	{
		key: "fog",
		src: iconFog,
	},
	{
		key: "thunderstorm",
		src: iconThunderstorm,
	},

	{
		key: "wind",
		src: iconWind,
	},
	{
		key: "dust",
		src: iconDust,
	},
	{
		key: "snow",
		src: iconSnow,
	},
	{
		key: "rain",
		src: iconRain,
	},
	{
		key: "wave",
		src: iconWave,
	},
	{
		key: "hail",
		src: iconHail,
	},
	{
		key: "temperature",
		src: iconTemp,
	},
	{
		key: "frost",
		src: iconFrost,
	},
];

export const formatDetailIconWithLayer = (type: string): string | null => {
	return (
		layersData.find((layer) => type.toLowerCase().includes(layer.key))?.src ??
		null
	);
};
